
const Header = ({title}: { title: string }) => {
    return (
        <>
            <h3 className="page-header my-2">{ title }</h3>
        </>
    )
}

export default Header;